
<app-page-wrapper
  [useHeader]="true"
  [useBackBtn]="true"
  [useFooter]="true"
  [title]="title"
  [subtitle]="subtitle"
>
  <ion-content>
    <div class="step-online-credit" *ngIf="loaded$ | async">
      <app-payment-form
              [formGroup]="formGroup"
              [formFieldsList]="formFields"
              [update]="choiceOfficeSub"
      >
      </app-payment-form>

      <div class="selected-office" *ngIf="selectedOffice">
        <strong>адрес:</strong>
        {{ selectedOffice.addr }}
        <strong>время работы:</strong>
        {{ selectedOffice.worktime }}
        <strong>телефоны:</strong>
        {{ selectedOffice.phone }}
      </div>
    </div>
  </ion-content>

  <ng-container footer *ngIf="loaded$ | async">
    <ion-button expand="block" class="button primary block" ripple-effect
                (click)="continueProcess()" [disabled]="formGroup.invalid">Далее
    </ion-button>
    <ion-button expand="block"
                class="button primary-light"
                ripple-effect
                (click)="abort()"
    >
      Отмена
    </ion-button>
  </ng-container>
</app-page-wrapper>


<!-- </app-page> -->
